import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';

export const containerPadding = css({
  padding: '40px 0',
  [MediaQueries.mdAndUp]: {
    paddingBottom: 80,
    paddingTop: 80,
  },
  [MediaQueries.lgAndUp]: {
    paddingBottom: 96,
    paddingTop: 96,
  },
});

export const headline = css(typography.effra48, {
  fontWeight: fontWeights.medium,
  marginBottom: 16,
  [MediaQueries.lgAndUp]: {
    marginBottom: 24,
  },
});

export const bodyDescription = css(typography.effra22Listing, {
  color: colorsPalette.grey80,
  marginBottom: 32,
});

export const buttonWrapper = css({
  marginBottom: 32,
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});

export const phoneNumber = css(typography.effra16, {
  color: colorsPalette.black,
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    height: '100%',
  },
});
